import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  main: {
    padding: "0px 0px 0px 0px",
    height: "100vh",
    width: "100%",
    margin: "auto",
    position: "relative",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",

    [theme.breakpoints.down("md")]: {
      height: "fit-content",
      padding: "30px 0px 30px 0px",
    },

    "& .number": {
      textAlign: "center",
      color: theme.palette.primary.main,
      fontWeight: "500",
      fontSize: "22px",
      margin: "0px 0px",
      width: "fit-content",
      fontFamily: "SFMono",
      display: "block",

      [theme.breakpoints.down("xl")]: {
        fontSize: "22px",
      },
    },

    "& .big-title": {
      textAlign: "center",
      color: theme.palette.text.light,
      fontWeight: "500",
      fontSize: "80px",
      margin: "20px 0px 0px 0px",
      letterSpacing: "0px",

      [theme.breakpoints.down("xl")]: {
        fontSize: "60px",
      },

      [theme.breakpoints.down("md")]: {
        fontSize: "40px",
      },
    },

    "& .desc": {
      textAlign: "center",
      color: theme.palette.text.dark,
      fontWeight: "300",
      fontSize: "28px",
      margin: "20px 0px 0px 0px",
      width: "50%",

      [theme.breakpoints.down("xl")]: {
        fontSize: "24px",
        fontWeight: "300",
        margin: "10px 0px 0px 0px",
        width: "60%",
      },

      [theme.breakpoints.down("md")]: {
        width: "100%",
        fontSize: "20px",
        // textAlign: "justify",
      },
    },

    "& span": {
      color: theme.palette.text.main,
      padding: "10px",
      fontWeight: "400",

      "&:hover": {
        color: theme.palette.primary.main,
        textDecoration: "underline",
      },
    },
    "& .divider": {
      width: "90%",
      height: "3px",
      backgroundColor: theme.palette.text.dark,
      margin: "100px 0px 10px 0px",
    },
    "& .copyright": {
      textAlign: "center",
      color: theme.palette.text.dark,
      fontWeight: "400",
      fontSize: "18px",
      margin: "20px 0px 0px 0px",
    },
    "& img": {
      display: "inline-block",
      width: "20px",
      margin: "20px 0px 0px 15px",
      transition: "all 0.2s",
      cursor: "pointer",

      [theme.breakpoints.down("xl")]: {
        width: "35px",
      },
      [theme.breakpoints.down("md")]: {
        width: "30px",
      },

      "&:hover": {
        transform: "translateY(-4px)",

      },
    },
  },
}));
